import { FTProcess } from '@/models/FTProcess';

import * as Slitting from './Slitting';
import * as BagForming from './BagForming'
import * as CupForming from './CupForming'
import * as Doilies from './Doilies'
import * as Lamination from './Lamination'
import * as PSLPrinting from './PSLPrinting'
import * as PaperPrinting from './PaperPrinting'
import * as Sheeting from './Sheeting'
import * as TrayForming from './TrayForming'
import * as Coating from './Coating'
import * as Corrugating from './Corrugating'
import * as DieCutting from './DieCutting'
import * as GuillotineCutting from './GuillotineCutting'
import * as AutomaticDieCutting from './AutomaticDieCutting'
import * as Embossing from './Embossing'
import * as Packing from './Packing';
import * as SachetForming from './SachetForming'
import * as NarrowSlitting from './NarrowSlitting'
import * as Trading from './Trading'
import { FTProcessRow } from '@/models/FTProcessRow';
import { ConversionDetails } from '@/models/ConversionDetails';


export const processHelpers :  {[key: string]: { loadConfig: (parsedVariables: ParsedVariables) => ProcessConfig, convert: (process: FTProcess) => ConversionResults }} = {
    Slitting,
    'Bag Forming': BagForming,
    'Cup Forming': CupForming,
    Doilies,
    Lamination,
    'PSL Printing': PSLPrinting,
    'Paper Printing': PaperPrinting,
    Sheeting,
    'Tray Forming': TrayForming,
    Coating,
    Corrugating,
    'Die Cutting': DieCutting,
    'Guillotine Cutting': GuillotineCutting,
    'Automatic Die Cutting': AutomaticDieCutting,
    Embossing,
    Packing,
    'Sachet Forming': SachetForming,
    'Narrow Slitting': NarrowSlitting,
    Trading
}

export interface ConversionResults {
  inputs: FTProcessRow[];
  outputs: FTProcessRow[];
  details: ConversionDetails;
}

export interface ProcessConfig {
  settings?: any; // @TODO: define settings
  goodsFilter?: Object;
  inputs: { goods: any[] }; // @TODO: define inputConfig
  outputs: Object;
  tableHeaders: Array<object>;
}

export interface ParsedVariables {
  process: FTProcess,
  processRow?: FTProcessRow
}

const shapes : any = {
  Round: {
      params: ['diameter'],
      area: ({ diameter } : any) => Math.PI * Math.pow(diameter / 2, 2),
  },
  Oval: {
      params: ['width', 'length'],
      area: ({ width, length } : any) => Math.PI * Math.pow(length * width / 4, 2),
  },
  Rectangle: {
      params: ['width', 'length'],
      area: ({ width, length } : any) => length * width,
  },
  'Rectangle + Oval': {
      params: ['width', 'length'],
      area: ({ width, length } : any) => {
          const circleArea = Math.PI * Math.pow(length / 2, 2);
          const rectArea = length * width;
          return (circleArea + rectArea);
      },
  },
  Other: {
      params: ['area'],
      area: ({ area } : any) => area,
  },
};

export function weightToLength(rollWeightKg : number, rollGsm : number, rollWidthMm : number) {
  const quantityInGrams = rollWeightKg * 1000;
  const widthInMeter = rollWidthMm / 1000;
  const outputLength = quantityInGrams / (rollGsm * widthInMeter);
  return outputLength;
}

export function weightToPieces(rollWeightKg : number, rollGsm : number, pieceAreaMm2 : number) {
  const quantityInGrams = rollWeightKg * 1000;
  const areaInMeter = pieceAreaMm2 / 1000000;
  const outputPieces = quantityInGrams / (rollGsm * areaInMeter);
  return outputPieces;
}

export function shapeArea({ shape, params, outUnit = 'mm' } : any) {
  const unitDivider = outUnit == 'm' ? 1000000 : 1;
  return getShapeParams(shape).area(params) / unitDivider
}

function getShapeParams(shape : any) : { area: any } {
  return shapes[shape] || shapes.Rectangle;
}

// Initializes the process for all the conversions
export function initProcess(process: any) {
  process.machineDetail.pcsPerStroke = 1;
  return process;
}
